export var RequestStatuses;
(function (RequestStatuses) {
    RequestStatuses["PendingRequest"] = "Pending Request";
    RequestStatuses["PendingApproval"] = "Pending Approval";
    RequestStatuses["Rejected"] = "Rejected";
    RequestStatuses["NeedsUpdates"] = "Needs Updates";
    RequestStatuses["PendingRecommendation"] = "Pending Recommendation";
    RequestStatuses["ReportReady"] = "Report Ready";
    RequestStatuses["ReportReceive"] = "Report Received";
})(RequestStatuses || (RequestStatuses = {}));
